export default __webpack_public_path__ + "static/media/hht1_ep19_timeline_04_blank.a8ccebee.png";